import { render } from "./AddPart.vue?vue&type=template&id=300ebdaf"
import script from "./AddPart.vue?vue&type=script&lang=js"
export * from "./AddPart.vue?vue&type=script&lang=js"
script.render = render

export default script